import { MovingBorderContainer } from '@components/ui/moving-border';

export const Badge = ({ text }: { text: string }) => {
  return (
    <MovingBorderContainer>
      <a
        href="#"
        className="w-fit mb-0! bg-white no-underline group mb-8 cursor-default relative  shadow-2xl shadow-zinc-200 rounded-full p-px text-xs font-semibold leading-6 text-black inline-block"
      >
        <span className="absolute inset-0 overflow-hidden rounded-full">
          <span className="absolute inset-0 rounded-full bg-[image:radial-gradient(75%_100%_at_50%_0%,rgba(56,189,248,0.6)_0%,rgba(56,189,248,0)_75%)] opacity-0 transition-opacity duration-500 group-hover:opacity-100"></span>
        </span>
        <div className="relative flex space-x-2 items-center z-10 rounded-full bg-white py-0.5 px-4 ring-1 ring-black/10 ">
          <span>{text}</span>
        </div>
        <span className="absolute -bottom-0 left-[1.125rem] h-px w-[calc(100%-2.25rem)] bg-gradient-to-r from-emerald-400/0 via-emerald-400/90 to-emerald-400/0 transition-opacity duration-500 group-hover:opacity-40"></span>
      </a>
    </MovingBorderContainer>
  );
};
